import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {IndexComponent} from "./pages/index/index.component";
import {HomeComponent} from "./pages/home/home.component";
import {Routing} from "./app.routing";
import {FormsModule} from "@angular/forms";
import {PpComponent} from "./pages/privacy-policy/pp.component";
import {TermOfUseComponent} from "./pages/term-of-use/term-of-use.component";
import {HomeService} from "./pages/home/home.service";
import {HttpClient, HttpClientModule} from "@angular/common/http";

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        IndexComponent,
        PpComponent,
        TermOfUseComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        Routing,
        FormsModule,
        HttpClientModule
    ],
    providers: [HomeService],
    bootstrap: [AppComponent]
})
export class AppModule {
}
